module.exports = __webpack_public_path__ + "img/git-commit.5abcd60f.svg";